// @ts-nocheck


import { fetchRequest } from './index';

import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';

export const convertDataToServer = (
washingCalculationMonth) => (
{
  ...washingCalculationMonth,
  cost: convertFromRubToKop(washingCalculationMonth.cost)
});

export const convertDataFromServer = (
washingCalculationMonth) => (
{
  ...washingCalculationMonth,
  cost: convertFromKopToRub(washingCalculationMonth.cost)
});

export const updateCalculations = async (
data) =>
{
  const updated = await fetchRequest.put(
    `/${basedUrl}/updateCalculation`,
    convertDataToServer(data)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error(`Не удалось отредактировать`);
};

const basedUrl = 'washingCalculationMonth';
const washingCalculationMonth = new CommonApi(
  basedUrl,
  'расчет потребности в мойке ТС',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...washingCalculationMonth,
  updateCalculations
};
